module.exports = __webpack_public_path__ + "static/img/X智慧云平台.bcd7b4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/model/360°全景环视系统/X智慧云平台.png
// module id = 2Z1q
// module chunks = 0